import { REVIEW_QUOTES, REVIEW_SHOTS } from "../../data/collection";
import { Reveal } from "./Reveal";

export default function Reviews() {
  return (
    <section
      id="reviews"
      data-testid="reviews"
      className="relative overflow-hidden bg-[#050505] text-white border-t border-white/10"
    >
      <div className="kln-noise" />
      <div className="relative mx-auto max-w-[1500px] px-6 md:px-12 lg:px-20 py-24 md:py-32">
        {/* header */}
        <div className="mb-14 md:mb-20 grid gap-8 md:grid-cols-12 md:items-end">
          <div className="md:col-span-8">
            <Reveal>
              <p className="font-body text-[11px] uppercase tracking-[0.4em] text-white/40">
                From our customers
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-display text-5xl md:text-7xl font-light leading-[0.92]">
                Loved, and
                <br />
                <span className="font-serif-editorial italic text-white/70">worn with joy.</span>
              </h2>
            </Reveal>
          </div>
          <div className="md:col-span-4">
            <Reveal delay={0.1}>
              <p className="max-w-sm font-body text-sm font-light leading-relaxed text-white/55">
                Real words from the women who wear Keilani — from Kerala to Germany.
              </p>
            </Reveal>
          </div>
        </div>

        {/* pull quotes */}
        <div className="grid gap-x-12 gap-y-10 md:grid-cols-3 mb-16 md:mb-20">
          {REVIEW_QUOTES.slice(0, 3).map((q, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <figure className="border-t border-white/15 pt-6">
                <span className="font-serif-editorial text-4xl leading-none text-[var(--kln-gold)]">
                  &ldquo;
                </span>
                <blockquote className="mt-2 font-serif-editorial text-xl md:text-2xl font-light italic leading-snug text-white/85">
                  {q.text}
                </blockquote>
                <figcaption className="mt-5 font-body text-[10px] uppercase tracking-[0.28em] text-white/40">
                  {q.author}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>

      {/* screenshot strip */}
      <Reveal>
        <div
          className="no-scrollbar flex gap-4 overflow-x-auto px-6 pb-24 md:px-12 lg:px-20"
          data-testid="reviews-gallery"
        >
          {REVIEW_SHOTS.map((src, i) => (
            <div
              key={i}
              className="relative w-[220px] md:w-[260px] shrink-0 overflow-hidden border border-white/10"
            >
              <img
                src={src}
                alt={`Customer review ${i + 1}`}
                loading="lazy"
                className="h-full w-full object-cover"
              />
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
